import { ReactNode } from 'react';
import { Box, IBoxProps } from '..';

export const PageWrapper = ({
  children,
  paddingTop = "gutter",
  paddingBottom = "gutter",
}: {
  children: ReactNode;
} & Pick<IBoxProps, 'paddingBottom' | 'paddingTop'>) => {
  return (
    <Box as="main" paddingTop={paddingTop} paddingBottom={paddingBottom}>
      {children}
    </Box>
  );
};
